/**
 * Private Route Component
 * Protects routes that require authentication
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ROUTES } from '../shared/constants/routes';
import { ROUTE_PERMISSIONS } from '../shared/constants/routes';

function PrivateRoute({ children, requiredRole }) {
  const { isAuthenticated, loading, userRole } = useAuth();

  if (loading) {
    return <div>Loading...</div>; // Or a loading spinner component
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  // Check role-based access
  if (requiredRole) {
    const allowedRoles = ROUTE_PERMISSIONS[window.location.pathname] || [];
    if (!allowedRoles.includes(userRole)) {
      return <Navigate to={ROUTES.DASHBOARD} replace />;
    }
  }

  return children;
}

export default PrivateRoute;






